<template>
  <section id="profile">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 relative">
      <div class="relative">
        <!-- Section header -->
        <div class="max-w-6xl mx-auto px-4 sm:px-6">
          <div class="py-12 md:py-20">
            <!-- Section header -->
            <div class="max-w-3xl mx-auto text-theme-900 text-center pb-12 md:pb-20">
              <h2 class="h2 text-3xl mb-12" data-aos="fade-up" data-aos-id-profile>プロフィール</h2>
              <img
                class="w-1/2 mb-4 mx-auto"
                :src="require('@/images/takahashi-face.png')"
                data-aos="fade-up"
                data-aos-anchor="[data-aos-id-profile]"
              />
              <p
                class="text-2xl font-bold text-theme-800"
                data-aos="fade-up"
                data-aos-anchor="[data-aos-id-profile]"
                data-aos-delay="100"
              >
                高橋 章友
              </p>
            </div>

            <!-- Items -->
            <div
              class="max-w-lg mx-auto grid gap-8 grid-cols-1 sm:grid-cols-2 lg:gap-16 items-start md:max-w-2xl lg:max-w-none"
              data-aos-id-profiles
            >
              <!-- 1st item -->
              <div
                class="relative flex flex-col items-center"
                data-aos="fade-up"
                data-aos-anchor="[data-aos-id-profile]"
                data-aos-delay="200"
              >
                <h4 class="h4 text-theme-900 mb-2">スキル</h4>
                <ul class="text-theme-800">
                  <li>理学療法士（国家資格）</li>
                  <li>セルフケアストレッチ</li>
                  <li>運動指導</li>
                  <li>生活習慣指導</li>
                  <li>
                    施術（首、肩のこり、腰痛、慢性疲労など）
                  </li>
                  <li>
                    講義（解剖学、生理学、症状メカニズムなど）
                  </li>
                </ul>
              </div>

              <!-- 2nd item -->
              <div
                class="relative flex flex-col items-center"
                data-aos="fade-up"
                data-aos-anchor="[data-aos-id-profile]"
                data-aos-delay="300"
              >
                <h4 class="h4 text-theme-900 mb-2">実績</h4>
                <ul class="text-theme-800">
                  <li>アスリート、芸能人、アイドルグループ担当</li>
                  <li>DMMラウンジ文化祭2016出演</li>
                  <li>週刊女性にストレッチ体操掲載</li>
                  <li>フジテレビアンチエイジングフェア2016出演</li>
                  <li>ストレッチ教室延べ1400回以上開催</li>
                  <li>5000人以上の施術実績</li>
                  <li>B-by-C株式会社医療顧問（2016~現在）</li>
                  <li>体質改善デトックスプログラム延べ300人以上担当</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Profiles",
  components: {},
  data: function() {
    return {}
  },
}
</script>

<style scoped>
.bg-image-1 {
  background-image: url("./../images/services-background-01.jpg");
  background-size: cover;
  background-position: center;
}
.bg-image-2 {
  background-image: url("./../images/services-background-02.jpg");
  background-size: cover;
  background-position: center;
}
.bg-image-3 {
  background-image: url("./../images/services-background-03.jpg");
  background-size: cover;
  background-position: center;
}
.button {
  width: 240px;
  right: 0;
  bottom: 0;
  margin-right: 2rem;
  margin-bottom: 2rem;
  cursor: pointer;
}
</style>
